/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TenantList_Tenant = {
    readonly id: string;
    readonly name: string;
    readonly host: {
        readonly id: string;
        readonly baseUrl: string;
    };
    readonly " $refType": "TenantList_Tenant";
};
export type TenantList_Tenant$data = TenantList_Tenant;
export type TenantList_Tenant$key = {
    readonly " $data"?: TenantList_Tenant$data;
    readonly " $fragmentRefs": FragmentRefs<"TenantList_Tenant">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "TenantList_Tenant",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Host",
                "kind": "LinkedField",
                "name": "host",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "baseUrl",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Tenant",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '66460c4a1e77760431686d4e5ff9224f';
export default node;
